import { render, staticRenderFns } from "./migrate.vue?vue&type=template&id=0433a72a&"
import script from "./migrate.vue?vue&type=script&lang=js&"
export * from "./migrate.vue?vue&type=script&lang=js&"
import style0 from "./migrate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports